<template id="aboutInfo">
<span>
<section>
  <div class="fullTwoColumnInfo">
    <div class="fullwidthLeftCol">
      <div class="content">
        <div class="mainIcon"><img alt="#" src="images/target.png"></div>
        <h2>{{info.res.target}}</h2>
        <p class="greyColorText" v-html="info.res.target_desc"></p>
        <a class="buttonStyle" v-html="info.res.target_note"></a> </div>
    </div>
    <div class="fullwidthRightCol">
      <div class="content">
        <div class="mainIcon"><img alt="#" src="images/product.png"></div>
        <h2>{{info.res.products}}</h2>
        <p v-html="info.res.products_desc"></p>
        <div class="productInfoIcons"><img alt="#" src="images/ic_product_a.png"><img alt="#" src="images/ic_product_b.png"><img alt="#" src="images/ic_product_c.png"><img alt="#" src="images/ic_product_d.png"></div>
      </div>
    </div>
    <div class="clearFix"></div>
  </div>
</section>
<section class="onmobile-hide">
  <div class="fullTwoColumnInfo Remove-margin">
    <div class="fullwidthLeftColimage">
      <div class="content-left-image"> <img class="img-respomsive" alt="#" src="images/our_edge.jpg"> </div>
    </div>
    <div class="fullwidth-textRightCol">
      <div class="content-right-text">
        <h3>{{info.res.edges}}</h3>
        <h5>{{info.res.history}}</h5>
        <p v-html="info.res.history_desc"></p>
        <h5>{{info.res.price}}</h5>
        <p v-html="info.res.price_desc"></p>
      </div>
    </div>
  </div>
  <div class="clearFix"></div>
  
</section>
<section class="mobileview-Ouredge">
  <div class="Background_view">
    <div class="container">
      <div class="col-xs-12">
        <div class="Text-background">
          <h2>{{info.res.edges}}</h2>
          <p v-html="info.res.edges_desc">As we also operate our retail website - SampsonStore.com since 2002, we have tremendous retail experiences in getting good and fascinating products to our end customers. We could make good recommendations for you to start your business quick.</p>
        </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="container-fluid Remove_pading">
    <div class="Our-prices">
      <div class="col-xs-12">
        <h5>{{info.res.price}}</h5>
        <p v-html="info.res.price_desc">as we mainly deal with manufacturer and brand owners only.</p>
      </div>
      <div class="col-xs-12 Remove_pading">
        <div class="Our-prices"> <img class="img-respomsive" alt="#" src="images/our_edge.png"> </div>
      </div>
    </div>
  </div>
</section>
<section>
  <div class="fullTwoColumnInfo Remove-margin">
    <div class="fullwidth-textRightCol">
      <div class="content-right-text Shipment-content">
        <h6>{{info.res.service_level}}</h6>
        <p v-html="info.res.service_level_desc">Also, our service level is among the top tier in the industry. Our relationship with all leading brands as a high volume distributor also guarantees that you will receive authentic and fresh products. We guarantee all condom products has at least 18 months and all lubricant products has at least 12 months of shelf-life by the time you receive the products.</p>
        <h6>{{info.res.shipment}}</h6>
        <p v-html="info.res.shipment_desc">As long as your delivery location do not violate our agreement with the brand distributor, we would be able to ship you the products by taking an appropriate shipment method at a lower cost with reasonable delivery lead time.</p>
      </div>
    </div>
    <div class="fullwidthLeftColimage">
      <div class="content-right-image"> <img class="img-respomsive" alt="#" src="images/our_edge_right.jpg"> </div>
    </div>
  </div>
  <div class="clearFix"></div>
</section>
</span>
</template>

<script>

export default {
  name: 'aboutInfo',
  props:['name', 'sname', 'content', 'slist', 'info'],
  data () {
    return {
    }
  },
  components: {
  },
  methods: {
  },
  mounted: function() {
//console.log(JSON.stringify(this.info));
  }
}
</script>



// WEBPACK FOOTER //
// src/components/AboutInfo.vue